import { Stream } from 'stream';
import { EXTENSION_FILES } from '../constants/common';
import { getCookie } from '@cat-ecom/common/utils/cookieUtils';
import { FAULT_INJECT } from 'components/my-equipment/constants';
import * as ExcelJS from 'exceljs';
import { FILE_FORMATS } from 'constants/common';
import { UploadFileConfig } from '@blocks-web-components/components/file-upload/file-upload.model';

export const validateFile = (
  item: { uploadedFiles: UploadFileConfig[] },
  statusText: string
) => {
  const { fileObject, fileSizeExceeded, fieldId, status } =
    item.uploadedFiles[0];
  const fileExtension = fileObject[1]?.name?.split('.').pop();
  const isValidFile = EXTENSION_FILES.includes(fileExtension);
  const cookieValue = getCookie(FAULT_INJECT.FILE_UPLOAD.type);

  if (fileSizeExceeded) {
    return { error: 'FAILED_FILE_SIZE_EXCEEDED', data: [] };
  }

  if (!isValidFile) {
    return { error: 'FAILED_FILE_TYPE_ISNOT_SUPPOERTED', data: [] };
  }

  if (
    status === 'Failed' ||
    cookieValue === FAULT_INJECT.FILE_UPLOAD.genericError
  ) {
    return { error: 'FAILED_FILE_CANNOT_BE_UPLOADED', data: [] };
  }

  return {
    error: '',
    data: [{ fileId: fieldId, status: 'Success', statusText, fileObject }]
  };
};

export const getSheetMatrix = async (
  sheet: ExcelJS.Worksheet
): Promise<ExcelJS.CellValue[][]> => {
  const data: ExcelJS.CellValue[][] = [];
  sheet.eachRow((tableRow) => {
    const row = [];
    tableRow.eachCell({includeEmpty: true},(cell) => row.push(cell.value));
    data.push(row);
  });
  return data;
};

export const parseFiles = async (file: File) => {
  const arrayBuffer = await file.arrayBuffer();
  const buffer = Buffer.from(arrayBuffer);
  const workbook = new ExcelJS.Workbook();
  const stream = new Stream.Readable();
  stream.push(buffer);
  stream.push(null);

  const { name } = file;
  if (name.endsWith(`.${FILE_FORMATS.csv}`)) {
    await workbook.csv.read(stream);
  } else if (name.endsWith(`.${FILE_FORMATS.xlsx}`)) {
    await workbook.xlsx.read(stream);
  } else {
    throw new Error('Unsupported File Format');
  }
  const data = await getSheetMatrix(workbook.worksheets[0]);
  return convertToOrderItems(data);
};

export const convertToOrderItems = (data: ExcelJS.CellValue[][]) => {
  const headers = data[0];
  const rows = data.slice(1);
  const headerMap = {
    0: 'quantity',
    1: 'partNumber',
    2: 'serialNumber',
    3: 'note',
    4: 'customerPartNumber',
    5: 'customerItemNumber'
  };

  const orderItems = rows.reduce((acc, row) => {
    const item = headers.reduce((obj, _, index) => {
      const key = headerMap[index];
      if (key) {
        obj[key] = row[index];
      }
      return obj;
    }, {});
    return [...acc, item];
  }, []);

  return orderItems;
};
